<template>
    <div>
        <!-- 1. Biaya Admin per Tipe Pinjaman -->
        <b-form @submit.prevent="openModalConfirmAdmin">
            <div class="parameter-section-card mb-4">
                <h6 class="parameter-card-title">Biaya Admin per Tipe Pinjaman</h6>
                <p class="parameter-card-subtitle">Baris mengikuti data master Tipe Pinjaman yang berstatus aktif.</p>

                <div class="table-responsive">
                    <table class="table parameter-matrix-table mb-0">
                        <thead>
                            <tr>
                                <th style="width: 24%;">TIPE PINJAMAN</th>
                                <th style="width: 19%;">ADMIN AWAL</th>
                                <th style="width: 19%;">MIN. AWAL</th>
                                <th style="width: 19%;">ADMIN BULANAN</th>
                                <th style="width: 19%;">MIN. BULANAN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="localJenisPinjamanList.length === 0">
                                <td colspan="5" class="text-center py-3 text-muted">Memuat data tipe pinjaman...</td>
                            </tr>
                            <tr v-for="(item, idx) in localJenisPinjamanList" :key="idx">
                                <td class="align-middle">
                                    <div class="font-weight-bold text-dark">{{ item.jenisPinjamanName }}</div>
                                    <span class="badge-kode-subtle" v-if="item.jenisPinjamanKode">{{ item.jenisPinjamanKode }}</span>
                                </td>
                                <td class="align-middle">
                                    <b-input-group append="%" class="input-group-custom">
                                        <b-form-input v-model="item.admAwalPersen" type="number" step="0.01" class="form-control-custom text-right" required></b-form-input>
                                    </b-input-group>
                                </td>
                                <td class="align-middle">
                                    <b-input-group prepend="Rp." class="input-group-custom">
                                        <b-form-input v-model="item.admAwalNominalMinFormatted" @input="val => formatMinAwal(val, item)" class="form-control-custom text-right" required></b-form-input>
                                    </b-input-group>
                                </td>
                                <td class="align-middle">
                                    <b-input-group append="%" class="input-group-custom">
                                        <b-form-input v-model="item.admBulananPersen" type="number" step="0.01" class="form-control-custom text-right"></b-form-input>
                                    </b-input-group>
                                </td>
                                <td class="align-middle">
                                    <b-input-group prepend="Rp." class="input-group-custom">
                                        <b-form-input v-model="item.admBulananNominalMinFormatted" @input="val => formatMinBulanan(val, item)" class="form-control-custom text-right"></b-form-input>
                                    </b-input-group>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button type="submit" class="btn btn-save-primary" :disabled="isSubmittingAdmin">
                        <b-spinner small v-if="isSubmittingAdmin" class="mr-1"></b-spinner>
                        {{ isSubmittingAdmin ? 'Menyimpan...' : 'Simpan' }}
                    </button>
                </div>
            </div>
        </b-form>

        <!-- 2. Biaya Admin per Jenis Barang (CRUD Override) -->
        <div class="parameter-section-card">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                <div>
                    <h6 class="parameter-card-title mb-1">Biaya Admin per Jenis Barang</h6>
                    <p class="parameter-card-subtitle mb-0">Pengecualian atas biaya admin tipe pinjaman. Hanya jenis barang yang ditambahkan di sini yang memakai tarif khusus.</p>
                </div>
                <button type="button" class="btn btn-tambah-primary" @click="openModalTambahBarang">
                    <i class="fa fa-plus mr-1"></i> Tambah Biaya Admin
                </button>
            </div>

            <div class="table-responsive">
                <table class="table custom-table-override mb-0">
                    <thead>
                        <tr>
                            <th style="width: 25%;">TIPE PINJAMAN</th>
                            <th style="width: 30%;">JENIS BARANG</th>
                            <th style="width: 18%;" class="text-right">PERSENTASE</th>
                            <th style="width: 17%;" class="text-right">BIAYA MINIMUM</th>
                            <th style="width: 10%;" class="text-center">AKSI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="barangJenisListFiltered.length === 0">
                            <td colspan="5" class="text-center py-4 text-muted">Belum ada biaya admin khusus jenis barang.</td>
                        </tr>
                        <tr v-for="(item, idx) in barangJenisListFiltered" :key="idx">
                            <td class="align-middle text-muted">{{ getTipePinjamanName(item) }}</td>
                            <td class="align-middle font-weight-600 text-dark">{{ item.barangJenisName }}</td>
                            <td class="align-middle text-right font-weight-600 text-dark">{{ item.admPersen !== null && item.admPersen !== undefined ? item.admPersen + ' %' : '-' }}</td>
                            <td class="align-middle text-right font-weight-600 text-dark">{{ item.admNominalMin ? 'Rp. ' + $helper.addThousandSeparator(item.admNominalMin) : '-' }}</td>
                            <td class="align-middle text-center">
                                <span class="action-link text-primary mr-2" @click="editBarangJenis(item)">Ubah</span>
                                <span class="action-link text-danger" @click="confirmDeleteBarangJenis(item)">Hapus</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Modal Tambah / Edit Biaya Admin Khusus -->
        <b-modal 
            id="modal-barang-admin" 
            centered 
            hide-header 
            hide-footer
            body-class="p-0"
            content-class="modal-custom-card"
        >
            <div class="modal-body-wrapper p-4">
                <!-- Modal Header -->
                <div class="d-flex align-items-start justify-content-between mb-3">
                    <div>
                        <h5 class="modal-custom-title mb-1">
                            {{ isEditingModal ? 'Ubah Biaya Admin Jenis Barang' : 'Tambah Biaya Admin Jenis Barang' }}
                        </h5>
                        <p class="modal-custom-subtitle mb-0">
                            Tarif ini menimpa biaya admin tipe pinjaman untuk jenis barang terpilih.
                        </p>
                    </div>
                    <button type="button" class="btn-modal-close" @click="$bvModal.hide('modal-barang-admin')">
                        <i class="fa fa-times"></i>
                    </button>
                </div>

                <b-form @submit.prevent="submitModalBarangAdmin">
                    <!-- TIPE PINJAMAN -->
                    <div class="form-group-custom mb-3">
                        <label class="modal-field-label">TIPE PINJAMAN <span class="text-danger">*</span></label>
                        <div class="chips-container d-flex flex-wrap">
                            <button
                                type="button"
                                v-for="tp in optTipePinjaman"
                                :key="tp.id"
                                class="btn-chip mr-2 mb-2"
                                :class="{ 'active': modalForm.tipePinjamanId === tp.id }"
                                :disabled="isEditingModal"
                                @click="selectTipePinjaman(tp.id)"
                            >
                                {{ tp.name }}
                            </button>
                        </div>
                    </div>

                    <!-- JENIS BARANG -->
                    <div class="form-group-custom mb-3">
                        <label class="modal-field-label mb-1">JENIS BARANG <span class="text-danger">*</span></label>
                        <div class="modal-field-helper mb-2">Pilih tipe pinjaman dulu untuk melihat jenis barangnya.</div>
                        <div class="chips-container d-flex flex-wrap">
                            <div v-if="optBarangJenisFiltered.length === 0" class="text-muted small py-1">
                                {{ modalForm.tipePinjamanId ? 'Tidak ada jenis barang pada tipe pinjaman ini.' : 'Belum ada tipe pinjaman yang dipilih.' }}
                            </div>
                            <button
                                type="button"
                                v-for="bj in optBarangJenisFiltered"
                                :key="bj.id"
                                class="btn-chip mr-2 mb-2"
                                :class="{ 'active': modalForm.barangJenisId === bj.id }"
                                :disabled="isEditingModal"
                                @click="selectBarangJenis(bj)"
                            >
                                {{ bj.name }}
                            </button>
                        </div>
                    </div>

                    <!-- PERSENTASE & BIAYA MINIMUM -->
                    <div class="row mb-3">
                        <div class="col-6">
                            <label class="modal-field-label">PERSENTASE <span class="text-danger">*</span></label>
                            <b-input-group append="%" class="input-group-custom">
                                <b-form-input 
                                    v-model="modalForm.admPersen" 
                                    type="number" 
                                    step="0.01" 
                                    placeholder="0,00" 
                                    class="form-control-custom" 
                                    required
                                ></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-6">
                            <label class="modal-field-label">BIAYA MINIMUM <span class="text-danger">*</span></label>
                            <b-input-group prepend="Rp." class="input-group-custom">
                                <b-form-input 
                                    v-model="modalForm.admNominalMinFormatted" 
                                    @input="formatModalMin" 
                                    placeholder="0" 
                                    class="form-control-custom" 
                                    required
                                ></b-form-input>
                            </b-input-group>
                        </div>
                    </div>

                    <!-- MODAL FOOTER BUTTONS -->
                    <div class="d-flex justify-content-end align-items-center mt-4 pt-2">
                        <button type="button" class="btn btn-modal-cancel mr-2" @click="$bvModal.hide('modal-barang-admin')">
                            Batal
                        </button>
                        <button 
                            type="submit" 
                            class="btn btn-modal-submit" 
                            :disabled="!modalForm.tipePinjamanId || !modalForm.barangJenisId || isSubmittingModal"
                        >
                            <b-spinner small v-if="isSubmittingModal" class="mr-1"></b-spinner>
                            {{ isEditingModal ? 'Simpan' : 'Tambah' }}
                        </button>
                    </div>
                </b-form>
            </div>
        </b-modal>

        <!-- Modal Confirm Simpan Biaya Admin -->
        <ModalConfirm 
            id="modal-confirm-biaya-admin" 
            title="Konfirmasi Perubahan Biaya Admin" 
            :isSubmitting="isSubmittingAdmin" 
            desc="Apakah anda yakin ingin menyimpan perubahan parameter biaya admin ini?" 
            @submit="onSubmitAdmin" 
        />

        <!-- Modal Confirm Hapus Biaya Admin Khusus -->
        <ModalConfirm 
            id="modal-confirm-delete-bjp-admin" 
            title="Konfirmasi Hapus Biaya Admin Khusus" 
            :isSubmitting="isSubmittingDelete" 
            desc="Apakah anda yakin ingin menghapus tarif biaya admin khusus untuk jenis barang ini?" 
            @submit="submitDeleteBarangJenis" 
        />
    </div>
</template>

<script>
export default {
    name: 'biaya-admin',
    props: {
        biayaAdminInput: { type: Object, default: () => ({}) },
        jenisPinjamanList: { type: Array, default: () => [] },
        barangJenisList: { type: Array, default: () => [] },
        wilayahId: { type: [Number, String], default: null }
    },
    data() {
        return {
            isSubmittingAdmin: false,
            isSubmittingModal: false,
            isSubmittingDelete: false,
            isEditingModal: false,
            localJenisPinjamanList: [],
            allBarangJenis: [],
            selectedDeleteItem: null,
            modalForm: {
                tipePinjamanId: null,
                barangJenisId: null,
                admPersen: null,
                admNominalMin: null,
                admNominalMinFormatted: ''
            }
        }
    },
    computed: {
        barangJenisListFiltered() {
            return (this.barangJenisList || []).filter(item => item.admPersen !== null || item.admNominalMin !== null)
        },
        optTipePinjaman() {
            return this.localJenisPinjamanList.map(item => ({
                id: item.jenisPinjamanId,
                name: item.jenisPinjamanName
            }))
        },
        optBarangJenisFiltered() {
            if (!this.modalForm.tipePinjamanId) return this.allBarangJenis
            return this.allBarangJenis.filter(b => b.jenisPinjamanId === this.modalForm.tipePinjamanId || b.tipePinjamanId === this.modalForm.tipePinjamanId)
        }
    },
    watch: {
        jenisPinjamanList: {
            handler(newVal) {
                this.localJenisPinjamanList = (newVal || []).map(item => ({
                    ...item,
                    admAwalNominalMinFormatted: this.$helper.addThousandSeparator(item.admAwalNominalMin || 0),
                    admBulananNominalMinFormatted: this.$helper.addThousandSeparator(item.admBulananNominalMin || 0)
                }))
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        formatMinAwal(val, item) {
            const num = String(val).replace(/\D/g, "")
            item.admAwalNominalMin = num ? parseInt(num) : 0
            item.admAwalNominalMinFormatted = this.$helper.addThousandSeparator(item.admAwalNominalMin)
        },
        formatMinBulanan(val, item) {
            const num = String(val).replace(/\D/g, "")
            item.admBulananNominalMin = num ? parseInt(num) : 0
            item.admBulananNominalMinFormatted = this.$helper.addThousandSeparator(item.admBulananNominalMin)
        },
        formatModalMin(val) {
            const num = String(val).replace(/\D/g, "")
            this.modalForm.admNominalMin = num ? parseInt(num) : 0
            this.modalForm.admNominalMinFormatted = this.$helper.addThousandSeparator(this.modalForm.admNominalMin)
        },

        getTipePinjamanName(item) {
            if (typeof item === 'object' && item !== null) {
                if (item.jenisPinjamanName) return item.jenisPinjamanName
                const found = this.localJenisPinjamanList.find(t => t.jenisPinjamanId === item.jenisPinjamanId)
                return found ? found.jenisPinjamanName : '-'
            }
            const found = this.localJenisPinjamanList.find(t => t.jenisPinjamanId === item)
            return found ? found.jenisPinjamanName : '-'
        },

        openModalConfirmAdmin() {
            this.$bvModal.show("modal-confirm-biaya-admin")
        },

        async onSubmitAdmin() {
            this.isSubmittingAdmin = true
            try {
                if (this.wilayahId && this.localJenisPinjamanList.length > 0) {
                    for (let item of this.localJenisPinjamanList) {
                        let payload = new FormData()
                        payload.append("wilayahId", this.wilayahId)
                        payload.append("jenisPinjamanId", item.jenisPinjamanId)
                        payload.append("bungaTenor1", item.bungaTenor1 || 0)
                        payload.append("bungaTenor2", item.bungaTenor2 || 0)
                        payload.append("admAwalPersen", item.admAwalPersen || 0)
                        payload.append("admAwalNominalMin", item.admAwalNominalMin || 0)
                        payload.append("admBulananPersen", item.admBulananPersen || 0)
                        payload.append("admBulananNominalMin", item.admBulananNominalMin || 0)
                        payload.append("dendaHarianPersen", item.dendaHarianPersen || 0)
                        payload.append("maxGadaiNominal", item.maxGadaiNominal || 0)

                        await this.$axios.post("parameter/update-jenis-pinjaman", payload)
                    }
                }

                this.$helper.toastSucc(this, "Biaya Admin per Tipe Pinjaman berhasil disimpan!")
                this.$bvModal.hide("modal-confirm-biaya-admin")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmittingAdmin = false
            }
        },

        async loadAllBarangJenis() {
            try {
                const res = await this.$axios.get("barang-jenis/")
                let list = Array.isArray(res.data) ? res.data : (res.data && Array.isArray(res.data.data) ? res.data.data : [])
                this.allBarangJenis = list.map(item => ({
                    id: item.id || item.jenisBarangId,
                    name: item.name || item.jenisBarangName,
                    jenisPinjamanId: (item.jenisPinjaman && item.jenisPinjaman.id) ? item.jenisPinjaman.id : (item.tipePinjamanId || item.jenisPinjamanId)
                }))
            } catch (e) {
                console.warn("Gagal load all barang jenis dari barang-jenis/, mencoba barang-jenis-atribut/:", e)
                try {
                    const res2 = await this.$axios.get("barang-jenis-atribut/")
                    let list2 = Array.isArray(res2.data) ? res2.data : (res2.data && Array.isArray(res2.data.data) ? res2.data.data : [])
                    this.allBarangJenis = list2.map(item => ({
                        id: item.jenisBarangId || item.id,
                        name: item.jenisBarangName || item.name,
                        jenisPinjamanId: item.tipePinjamanId || (item.jenisPinjaman ? item.jenisPinjaman.id : null)
                    }))
                } catch (e2) {
                    console.error("Gagal load all barang jenis:", e2)
                }
            }
        },

        openModalTambahBarang() {
            this.isEditingModal = false
            this.modalForm = {
                tipePinjamanId: null,
                barangJenisId: null,
                admPersen: null,
                admNominalMin: 0,
                admNominalMinFormatted: ''
            }
            this.loadAllBarangJenis()
            this.$bvModal.show("modal-barang-admin")
        },

        editBarangJenis(item) {
            this.isEditingModal = true
            this.modalForm = {
                tipePinjamanId: item.jenisPinjamanId,
                barangJenisId: item.barangJenisId,
                admPersen: item.admPersen,
                admNominalMin: item.admNominalMin || 0,
                admNominalMinFormatted: this.$helper.addThousandSeparator(item.admNominalMin || 0)
            }
            this.loadAllBarangJenis()
            this.$bvModal.show("modal-barang-admin")
        },

        onModalTipePinjamanChange() {
            this.modalForm.barangJenisId = null
        },

        selectTipePinjaman(id) {
            if (this.isEditingModal) return
            this.modalForm.tipePinjamanId = id
            this.modalForm.barangJenisId = null
        },

        selectBarangJenis(bj) {
            if (this.isEditingModal) return
            this.modalForm.barangJenisId = bj.id
            if (!this.modalForm.tipePinjamanId && bj.jenisPinjamanId) {
                this.modalForm.tipePinjamanId = bj.jenisPinjamanId
            }
        },

        async submitModalBarangAdmin() {
            if (!this.wilayahId || !this.modalForm.barangJenisId) return
            this.isSubmittingModal = true
            try {
                let payload = new FormData()
                payload.append("wilayahId", this.wilayahId)
                payload.append("barangJenisId", this.modalForm.barangJenisId)
                payload.append("admPersen", this.modalForm.admPersen || 0)
                payload.append("admNominalMin", this.modalForm.admNominalMin || 0)

                await this.$axios.post("parameter/update-barang-jenis", payload)
                this.$helper.toastSucc(this, "Biaya admin khusus jenis barang berhasil disimpan!")
                this.$bvModal.hide("modal-barang-admin")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmittingModal = false
            }
        },

        confirmDeleteBarangJenis(item) {
            this.selectedDeleteItem = item
            this.$bvModal.show("modal-confirm-delete-bjp-admin")
        },

        async submitDeleteBarangJenis() {
            if (!this.selectedDeleteItem || !this.selectedDeleteItem.id) return
            this.isSubmittingDelete = true
            try {
                await this.$axios.delete(`parameter/barang-jenis/${this.selectedDeleteItem.id}`)
                this.$helper.toastSucc(this, "Biaya admin khusus berhasil dihapus!")
                this.$bvModal.hide("modal-confirm-delete-bjp-admin")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmittingDelete = false
            }
        }
    },
    created() {
        this.loadAllBarangJenis()
    }
}
</script>

<style lang="scss" scoped>
.parameter-section-card {
    background-color: #ffffff;
    border: 1px solid #e2ece7;
    border-radius: 10px;
    padding: 20px 24px;
}

.parameter-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 2px;
}

.parameter-card-subtitle {
    font-size: 12.5px;
    color: #64748b;
    margin-bottom: 16px;
}

.parameter-matrix-table {
    thead th {
        background-color: transparent;
        color: #64748b;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        border-top: none;
        border-bottom: 1px solid #e2ece7;
        padding: 10px 12px;
    }

    tbody td {
        padding: 12px;
        border-top: 1px solid #edf4f1;
        border-bottom: none;
    }
}

.custom-table-override {
    thead th {
        background-color: #fafcfb;
        color: #64748b;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        border-top: none;
        border-bottom: 1px solid #e2ece7;
        padding: 12px 14px;
    }

    tbody td {
        padding: 14px;
        border-top: 1px solid #edf4f1;
        border-bottom: none;
        font-size: 13px;
    }
}

.badge-kode-subtle {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
    text-transform: uppercase;
}

.form-control-custom {
    border-radius: 8px !important;
    border: 1px solid #d8e2dc !important;
    font-size: 13px !important;
    height: 38px !important;
    color: #1e293b !important;

    &:focus {
        border-color: #0b3b36 !important;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12) !important;
    }
}

.input-group-custom {
    ::v-deep .input-group-text {
        background-color: #f8fafc;
        border-color: #d8e2dc;
        font-size: 12.5px;
        font-weight: 600;
        color: #64748b;
    }
}

.btn-save-primary {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 9px 32px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        box-shadow: 0 2px 8px rgba(11, 59, 54, 0.2);
    }
}

.btn-tambah-primary {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 700;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
        background-color: #082d29;
        border-color: #082d29;
    }
}

.action-link {
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.font-weight-600 {
    font-weight: 600;
}

/* Modal Custom Styling */
::v-deep .modal-custom-card {
    border-radius: 14px !important;
    border: none !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
    overflow: hidden;

    .modal-content {
        border-radius: 14px !important;
        border: none !important;
    }
}

.modal-custom-title {
    font-size: 16px;
    font-weight: 700;
    color: #0b3b36;
    letter-spacing: -0.2px;
}

.modal-custom-subtitle {
    font-size: 12.5px;
    color: #64748b;
    line-height: 1.4;
}

.btn-modal-close {
    background: transparent;
    border: none;
    color: #94a3b8;
    font-size: 16px;
    padding: 4px;
    cursor: pointer;
    line-height: 1;
    transition: color 0.15s ease;

    &:hover {
        color: #0f172a;
    }
}

.modal-field-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #64748b;
    text-transform: uppercase;
    margin-bottom: 6px;
    display: block;
}

.modal-field-helper {
    font-size: 12px;
    color: #64748b;
}

.btn-chip {
    background-color: #ffffff;
    border: 1px solid #d8e2dc;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none !important;

    &:hover:not(:disabled) {
        border-color: #0b3b36;
        color: #0b3b36;
        background-color: #f8fafc;
    }

    &.active {
        background-color: #0b3b36 !important;
        border-color: #0b3b36 !important;
        color: #ffffff !important;
        box-shadow: 0 2px 6px rgba(11, 59, 54, 0.2);
    }

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
}

.btn-modal-cancel {
    background: #ffffff;
    border: 1px solid #d8e2dc;
    color: #334155;
    border-radius: 8px;
    padding: 8px 24px;
    font-size: 13.5px;
    font-weight: 600;
    transition: all 0.15s ease;

    &:hover {
        background-color: #f1f5f9;
        color: #0f172a;
    }
}

.btn-modal-submit {
    background-color: #0b3b36;
    border: 1px solid #0b3b36;
    color: #ffffff;
    border-radius: 8px;
    padding: 8px 28px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        box-shadow: 0 2px 8px rgba(11, 59, 54, 0.2);
    }

    &:disabled {
        background-color: #9ab4aa !important;
        border-color: #9ab4aa !important;
        color: #ffffff !important;
        opacity: 0.85;
        cursor: not-allowed;
    }
}
</style>
